<template>
  <div>
    <h5>
      基本信息
    </h5>
    <el-descriptions
      class="margin-top"
      title=""
      :column="2"
      size="medium"
      direction="horizontal"
    >
      <el-descriptions-item label="任务名称">
        {{ current.name }}
      </el-descriptions-item>
      <el-descriptions-item label="任务类型">
        {{ formatLabel(current.taskType, TASK_LIST) }}
      </el-descriptions-item>
      <el-descriptions-item label="任务时间">
        {{ current.startTime +' - '+ current.endTime }}
      </el-descriptions-item>
      <el-descriptions-item label="任务次数">
        {{ current.executeNum }}次
      </el-descriptions-item>
      <el-descriptions-item label="循环机制">
        {{ formatLabel(current.cyclicType, CYCLIC_TYPE_LIST) }}
      </el-descriptions-item>
      <el-descriptions-item label="描   述">
        {{ current.description }}
      </el-descriptions-item>
    </el-descriptions>
    <div class="line" />
    <h5>
      应用范围
    </h5>
    <div class="table-box">
      <el-table
        height="100%"
        :data="current.users"
        border
        highlight-current-row
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
        />
        <el-table-column
          prop="companyName"
          label="分子公司"
        />
        <el-table-column
          prop="bizName"
          label="人员"
        />
      </el-table>
    </div>
  </div>
</template>

<script>
import { TYPE_LIST, TASK_LIST, CYCLIC_TYPE_LIST } from '../constant';

export default {
  name: 'CatDetails',
  props: {
    current: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      TYPE_LIST,
      TASK_LIST,
      CYCLIC_TYPE_LIST,
      tableList: [],

    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      if (this.mode === 'ADD') return '新增规则';
      if (this.mode === 'DETAILS') return '查看规则';
      return '编辑规则';
    },
  },
  methods: {
    formatLabel(val, list) {
      if (!val) {
        return val;
      }
      const [temp] = list.filter((item) => item.value === val);
      if (temp) {
        return temp.label;
      }

      if (val === 'IMMEDIATE_EXECUTION') {
        return '立即执行';
      }
      if (val === 'ONE_TIME') {
        return '一次';
      }

      return temp ? temp.label : val;
    },
    handleClose() {
      this.show = false;
    },
  },
};
</script>

  <style lang="scss" scoped>
  .table-box {
    margin-left: 30px;
    height: 405px;
  }
  h5{
    margin-left: 30px;
    border-left: 3px solid #1e3cbb;
    line-height: 13px;
    padding-left: 5px;
    font-size: 13px;
    margin-bottom: 15px;
    color: #1e3cbb;
  }
  .el-descriptions{
    margin-left: 30px;
    td{
      height: 40px;
    }
  }
  .line{
    margin: 20px 0 30px 30px;
    border-bottom: 1px solid #eee;
  }
  </style>
